 if (document.querySelector('.configurator')) {
	function parseDateFromString(dateString) {
    const [day, month, year] = dateString.split('.').map(Number);
    return new Date(year, month - 1, day);
}
	// Делегирование событий для динамически созданных элементов 
	document.addEventListener('click', function (e) {
		// Обработка кнопки увеличения
		if (e.target.classList.contains('guest__increment')) {
			const input = e.target.closest('.guest__controls').querySelector('.guest__input');
			let value = parseInt(input.value) || 0;
			input.value = value + 1;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		}

		// Обработка кнопки уменьшения
		if (e.target.classList.contains('guest__decrement')) {
			const input = e.target.closest('.guest__controls').querySelector('.guest__input');
			let value = parseInt(input.value) || 0;
			if (value > 0) {
				input.value = value - 1;
			}
			input.dispatchEvent(new Event('change', { bubbles: true }));

		}
	});


let currentDate = new Date();
let selectedDate = null;
let lastAvailableDate = null; // Переменная для хранения последней доступной даты

// Инициализация календаря
function initCalendar() {
	// Получаем последнюю доступную дату из атрибута
	const triggerButton = document.querySelector('.trigger-button');
	const lastDayAttr = triggerButton.getAttribute('data-lastday');
	console.log(lastDayAttr);
	if (lastDayAttr) {
		const parts = lastDayAttr.split('.');
		if (parts.length === 3) {
			lastAvailableDate = new Date(parts[2], parts[1] - 1, parts[0]);
			lastAvailableDate.setHours(23, 59, 59, 999); // Устанавливаем конец дня
		}
	}
	
	updateCalendar();

	// Закрытие календаря при клике вне его области
	document.addEventListener('click', function (event) {
		const calendarPopup = document.getElementById('calendarPopup');
		const triggerButton = document.querySelector('.trigger-button');

		if (!calendarPopup.contains(event.target) &&
			!triggerButton.contains(event.target)) {
			calendarPopup.classList.remove('show');
		}
	});
}

// Проверка, является ли дата прошедшей
function isPastDate(date) {
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	return date < today;
}

// Проверка, является ли дата позже последней доступной
function isAfterLastDate(date) {
	if (!lastAvailableDate) return false;
	return date > lastAvailableDate;
}

// Проверка, является ли месяц прошедшим относительно текущего месяца
function isPastMonth(date) {
	const current = new Date();
	const currentYear = current.getFullYear();
	const currentMonth = current.getMonth();
	const compareYear = date.getFullYear();
	const compareMonth = date.getMonth();

	return compareYear < currentYear ||
		(compareYear === currentYear && compareMonth < currentMonth);
}

// Проверка, является ли месяц будущим после последнего доступного
function isAfterLastMonth(date) {
	if (!lastAvailableDate) return false;
	
	const lastYear = lastAvailableDate.getFullYear();
	const lastMonth = lastAvailableDate.getMonth();
	const compareYear = date.getFullYear();
	const compareMonth = date.getMonth();
	
	return compareYear > lastYear ||
		(compareYear === lastYear && compareMonth > lastMonth);
}

// Проверка, будет ли следующий месяц при переходе прошедшим или превышающим последний
function isMonthUnavailable(direction) {
	const testDate = new Date(currentDate);
	testDate.setMonth(testDate.getMonth() + direction);
	
	if (direction === -1) {
		return isPastMonth(testDate);
	} else if (direction === 1) {
		return isAfterLastMonth(testDate);
	}
	return false;
}

// Обновление состояния кнопок навигации
function updateNavigationButtons() {
	const prevButton = document.getElementById('prevMonth');
	const nextButton = document.getElementById('nextMonth');

	// Отключаем кнопку "назад" если переход ведет на прошлый месяц
	const isPrevDisabled = isMonthUnavailable(-1);
	
	if (isPrevDisabled) {
		prevButton.classList.add('disabled');
		prevButton.disabled = true;
	} else {
		prevButton.classList.remove('disabled');
		prevButton.disabled = false;
	}

	// Отключаем кнопку "вперед" если переход ведет за последний доступный месяц
	const isNextDisabled = isMonthUnavailable(1);
	
	if (isNextDisabled) {
		nextButton.classList.add('disabled');
		nextButton.disabled = true;
	} else {
		nextButton.classList.remove('disabled');
		nextButton.disabled = false;
	}
}

// Обновление отображения календаря
function updateCalendar() {
	const monthYearElement = document.getElementById('currentMonthYear');
	const calendarGrid = document.getElementById('calendarGrid');

	// Установка названия месяца и года
	const monthNames = [
		'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
		'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
	];

	const currentYear = currentDate.getFullYear();
	const currentMonth = currentDate.getMonth();

	monthYearElement.textContent = `${monthNames[currentMonth]} ${currentYear}`;

	// Очистка сетки календаря
	calendarGrid.innerHTML = '';

	// Получение первого дня месяца и количества дней в месяце
	const firstDay = new Date(currentYear, currentMonth, 1);
	const lastDay = new Date(currentYear, currentMonth + 1, 0);
	const daysInMonth = lastDay.getDate();

	// Получение дня недели первого дня (0 - воскресенье, 1 - понедельник, и т.д.)
	let firstDayOfWeek = firstDay.getDay();
	// Преобразование к формату: 0 - понедельник, 6 - воскресенье
	firstDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

	// Добавление пустых ячеек для дней предыдущего месяца
	for (let i = 0; i < firstDayOfWeek; i++) {
		const emptyDay = document.createElement('button');
		emptyDay.className = 'calendar-day other-month';
		emptyDay.textContent = '';
		emptyDay.disabled = true;
		calendarGrid.appendChild(emptyDay);
	}

	// Добавление дней текущего месяца
	const today = new Date();
	today.setHours(0, 0, 0, 0);

	for (let day = 1; day <= daysInMonth; day++) {
		const dayElement = document.createElement('button');
		const cellDate = new Date(currentYear, currentMonth, day);
		cellDate.setHours(0, 0, 0, 0);

		dayElement.className = 'calendar-day';
		dayElement.textContent = day;

		// Проверка, является ли день сегодняшним
		if (cellDate.getTime() === today.getTime()) {
			dayElement.classList.add('today');
		}

		// Проверка, является ли день прошедшим
		if (isPastDate(cellDate)) {
			dayElement.classList.add('past-date');
			dayElement.disabled = true;
		}
		
		// Проверка, является ли день позже последней доступной даты
		if (isAfterLastDate(cellDate)) {
			dayElement.classList.add('past-date'); // Используем тот же стиль
			dayElement.disabled = true;
		}

		// Проверка, выбран ли этот день
		if (selectedDate && cellDate.getTime() === selectedDate.getTime()) {
			dayElement.classList.add('selected');
		}

		// Добавляем обработчик клика только для доступных дат (не прошедших и не позже последней)
		if (!isPastDate(cellDate) && !isAfterLastDate(cellDate)) {
			dayElement.addEventListener('click', function () {
				selectDate(cellDate);
			});
		}

		calendarGrid.appendChild(dayElement);
	}

	// Обновляем состояние кнопок навигации
	updateNavigationButtons();
}

// Смена месяца
function changeMonth(direction) {
	const newDate = new Date(currentDate);
	newDate.setMonth(newDate.getMonth() + direction);

	// Проверяем, можно ли перейти на этот месяц
	if ((direction === -1 && isMonthUnavailable(-1)) ||
		(direction === 1 && isMonthUnavailable(1))) {
		return; // Запрещаем переход на недоступные месяцы
	}

	currentDate = newDate;
	updateCalendar();
}

// Выбор даты
function selectDate(date, change=true) {
	selectedDate = date;
	updateCalendar();

	// Обновление текста кнопки
	const triggerButton = document.querySelector('.trigger-button');
	const day = date.getDate().toString().padStart(2, '0');
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const year = date.getFullYear();

	triggerButton.value = `${day}.${month}.${year}`;
	if(change){
		triggerButton.dispatchEvent(new Event('change', { bubbles: true }));
	}
	updateCalendar();
	// Закрытие календаря
	document.getElementById('calendarPopup').classList.remove('show');
}

// Показать/скрыть календарь
function toggleCalendar() {
	const calendarPopup = document.getElementById('calendarPopup');
	calendarPopup.classList.toggle('show');
}

document.querySelector('.trigger-button').addEventListener('click', toggleCalendar);

document.querySelector('.nav-button-prev').addEventListener('click', function () {
	changeMonth(-1);
});

document.querySelector('.nav-button-next').addEventListener('click', function () {
	changeMonth(1);
});

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', initCalendar);


	document.querySelector('.how-popup-js-open').addEventListener('click', function (e) {
		e.preventDefault();
		document.querySelector('.how-popup').classList.add('active');
	});
	document.querySelectorAll('.how-popup__js-close').forEach(function (closeButton) {
		closeButton.addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('.how-popup').classList.remove('active');
		});
	});
	document.querySelector('.tarifs-wrap__toggle').addEventListener('click', function () {
		document.querySelector('.tarifs-wrap').classList.toggle('_open');
	});

	document.addEventListener('mouseup', function(e) {
    var container = document.querySelector('.tarifs-wrap');
 
    if (!container.contains(e.target)) {
       document.querySelector('.tarifs-wrap').classList.remove('_open');
    }
});



	// Находим родительский элемент
const tarifsContainer = document.querySelector('.tarifs');

// Вешаем обработчик на родителя
tarifsContainer.addEventListener('click', function(event) {
  // Проверяем, что кликнули именно по инпуту
  if (event.target.classList.contains('tarif__input')) {
    const input = event.target;
    
    // Проверяем, не disabled ли инпут
    if (!input.disabled) {
      document.querySelector('.tarifs-wrap__toggle-text').innerHTML= input.closest('.tarif').querySelector('.tarif__title').innerHTML;
	  document.querySelector('.tarifs-wrap').classList.remove('_open');
    }
  }
});


	document.querySelector('.configurator').addEventListener('change', () => {
		let tarifs = document.querySelector('.tarifs')
		let guests = document.querySelector('.guests')
		let submitBtn = document.querySelector('.configurator__submit')
		let error = document.querySelector('.configurator__error')
		let total = document.querySelector('.configurator__total-price ')
		let times = document.querySelector('.times')
		let form = document.querySelector('.configurator');
		form.classList.add('form-sending');
		//console.log(form)
		fetch(form.dataset.update.length?form.dataset.update:form.action, {
			method: "POST",
			headers: {
				'Content-Type': 'application/json',
			},
			body: new FormData(form)
		})
			.then(response => {
				if (!response.ok) throw new Error('Network error');
				form.classList.remove('form-sending');
				return response.json();
			})
			.then(data => {
				//console.log('Успешная отправка:', data);
				
				total.innerHTML=data.total?data.total:'0';
				error.innerHTML=data.error?data.error:'';
				if(submitBtn && data.error && data.error!=''){
					submitBtn.disabled = true;
				}else{
					submitBtn.disabled = false;
				}
				const dateString = data.date;
				const [day, month, year] = dateString.split('.').map(Number);
				currentDate =  new Date(year, month - 1, day);
				selectDate(new Date(year, month - 1, day), false);
				tarifs.innerHTML = "";
				data.tarifs.forEach(tarif => {
					tarifs.insertAdjacentHTML('beforeend', `
						<label class="tarif">
							<input class="tarif__input" type="radio" name="tarif" ${tarif.isChecked == 'true' ? "checked" : ""}  ${tarif.isDisabled == 'true' ? "disabled" : ""} value="${tarif.value}">
							<span class="tarif__title">${tarif.title}</span>
							<span class="tarif__closed-text">${tarif.closeText}</span>
						</label>`);
				})
				times.innerHTML = "";
				data.times.forEach(time => {
					times.insertAdjacentHTML('beforeend', `
						 <label class="time"> 
                        <input class="time__input" type="radio" name="time" ${time.isChecked == 'true' ? "checked" : ""}  ${time.isDisabled == 'true' ? "disabled" : ""} value="${time.value}">
						<span class="time__pre-title">${time.preTitle}</span>
						<span class="time__title">${time.title}</span>
						<span class="time__closed-text${time.closeTextVisible == 'true' ? " _is-visible" : ""}">${time.closeText}</span>
                      </label>`);
				})
				guests.innerHTML = "";
				data.guests.forEach(guest => {
					guests.insertAdjacentHTML('beforeend', `
						 
					<div class="guest">
						<div class="guest__left">
							<div class="guest__title">${guest.title}</div>
							<div class="guest__sub-title">${guest.subTitle}</div>
						</div>
						<div class="guest__center">
							${guest.price ? '<div class="guest__price">' + guest.price + '</div>' : ""}
							${guest.desc ? '<div class="guest__desc">' + guest.desc + '</div>' : ""}
						</div>
						<div class="guest__controls">
							<button class="guest__decrement" type="button">-</button>
							<input class="guest__input" type="text" value="${guest.value}" name="${guest.name}" readonly>
							<button class="guest__increment" type="button">+</button>
						</div>
					</div>`);
				})
				form.classList.remove('form-sending');
			})
			.catch(error => {
				console.error('Ошибка:', error);
				form.classList.remove('form-sending');
			});
	})
}